import Vue from 'vue'

Vue.config.ignoredElements = [
  'django-cms-template',
  'django-cms-plugin',
  'cms-template',
  'cms-plugin',
];
const debug = true

export default {
  data() {
    return {
      DjangoCMSPatch: null
    }
  },
  created() {
    if (window.CMS_IS_AUTHENTICATED && window.CMS_IN_EDIT_MODE) {
      window.VueDjangoCMSPatchCounter = 0;
      (() => {
        const doCheck = () => {
          if (window.CMS_IS_AUTHENTICATED && window.CMS_IN_EDIT_MODE) {
            if (window.CMS !== undefined && window.CMS.config !== undefined) {
              this.DjangoCMSPatch = new VueDjangoCMSPatch(this, '#app-root', Vue)
            } else {
              window.VueDjangoCMSPatchCounter++;
              if (window.VueDjangoCMSPatchCounter !== 10) {
                setTimeout(doCheck, Math.exp(window.VueDjangoCMSPatchCounter));
              }
            }
          }
        };
        doCheck();
      })();
    }
  }
}


// Patch for Vue.js to enable DjangoCMS's "double click to edit" feature.
//
// To set it up you should call `new VueDjangoCMSPatch(this)` in a `created`
// hook on a Vue instance.
// And add 'django-cms-template' and 'cms-plugin' to `Vue.config.ignoredElements`.
const VueDjangoCMSPatch = function (instance, selector, Vue) {
  //we are in edit mode edit anabled and not edit mode published preview
  const canBePatched = function () {
    return window.CMS !== undefined && window.CMS.config.mode === 'draft';
  };

  const getTemplateNodesInElementThatDoNotHaveAnySlotDirective = (el) => {
    const ret = Array.prototype.slice.call(el.querySelectorAll('template')).filter((n) => {

      const inner = (
        n &&
        n.attributes &&
        ![...n.attributes].some(c => {
          return c.name.startsWith('slot') ||
            c.name.startsWith('v-slot') ||
            c.name.startsWith('data-v-slot')
        })
      )
      debug && console.log('inner', inner)
      return inner
    });
    debug && console.log('ret', ret)
    return ret
  };

  //changes the node tag for a set of passed nodes
  const updateNodesTag = (nodes, tag) => {
    for (let i = 0; i < nodes.length; i++) {
      const referenceNode = nodes[i];
      debug && console.log('referenceNode', referenceNode)
      debug && console.log('getTemplateNodesInElementThatDoNotHaveAnySlotDirective(referenceNode)', getTemplateNodesInElementThatDoNotHaveAnySlotDirective(referenceNode))
      if (
        !getTemplateNodesInElementThatDoNotHaveAnySlotDirective(referenceNode)
          .length
      ) {
        const newElement = document.createElement(tag);

        if (referenceNode.hasAttributes()) {
          const attrs = referenceNode.attributes;
          for (let j = attrs.length - 1; j >= 0; j--) {
            newElement.setAttribute(attrs[j].name, attrs[j].value);
          }
          newElement.innerHTML = referenceNode.innerHTML;
        } else {
          newElement.innerHTML = referenceNode.innerHTML;
        }

        debug && console.log('da')
        debug && console.log(referenceNode)
        debug && console.log(newElement)
        referenceNode?.parentNode?.insertBefore(newElement, referenceNode);
        referenceNode?.parentNode?.removeChild(referenceNode);
      }
    }
  };

  /*
    In this method we:
    1. take all scripts cms related inside a selector
    2. we remove them from the selector
    3. we append them at the end of the body
  */
  const moveCmsScriptTagsInsideElementToTheBottomOfBody = function (selector) {

    const scripts = document.querySelectorAll(selector + ' script[data-cms]');
    for (let i = 0; i < scripts.length; i++) {
      if (scripts[i].parentNode) {
        scripts[i]?.parentNode?.removeChild(scripts[i]);
        const script = scripts[i];
        document.body.appendChild(script);
      }
    }
  };

  /*
    In this method we:
    1. We return a promise that resolve when the script is loaded
  */
  const loadScriptAsAPromise = function (url) {
    return new Promise(function (resolve, reject) {
      const script = document.createElement('script');
      script.src = `${url}`;
      script.addEventListener('load', function () {
        resolve(true);
      });
      document.head.appendChild(script);
    });
  };

  /*
    In this method we:
    1. We load a set of script in Waterfall
  */
  const loadScriptsInWaterfall = async (scripts) => {
    for (let index = 0; index < scripts.length; index++) {
      const url = scripts[index];
      const loadedJs = await loadScriptAsAPromise(url);
    }
  };

  // Patch the cms
  const patch = (selector) => {
    /*
      Here we:
      1. go trought all <template> tags and transform them into <cms-template> keeping all attributes
      2. we select all the <cms-template> nodes that have a slot or v-slot directive
      4. we transform them back to template

      Example
        FROM:
          <template class="cms-plugin cms-plugin-start cms-plugin-116064"></template>
          <hero-cmp data-is-hover-animated="false">
            <template slot="title">EVENTI</template>
          </hero-cmp>
          <template class="cms-plugin cms-plugin-end cms-plugin-116064"></template>
        TO:
          <cms-template class="cms-plugin cms-plugin-start cms-plugin-116064"></cms-template>
          <hero-cmp data-is-hover-animated="false" class="cms-plugin-116064">
            <template slot="title">EVENTI</template>
          </hero-cmp>
          <cms-template class="cms-plugin cms-plugin-end cms-plugin-116064"></cms-template>


    */
    updateNodesTag(
      getTemplateNodesInElementThatDoNotHaveAnySlotDirective(document),
      'cms-template'
    );

    /*
      Move scripts inside templates outside of them
    */
    moveCmsScriptTagsInsideElementToTheBottomOfBody(selector);

    window.CMS.$('[data-cms-structure-btn]').trigger('click')



    // Gestione refresh plugin CMS al click sullo switcher
    window.CMS.$(window).on(
      'resize',
      () => {
        setTimeout(() => {
          window.CMS.Plugin._refreshPlugins();
        }, 0);
      },
    );

    if (!window.djangoCmsIsPatched) {
      window.djangoCmsIsPatched = true;

      window.CMS.$(window).on('cms-content-refresh', async () => {
        window.location.reload();
      });
    }
  };

  const init = function (selector) {
    if (canBePatched()) {
      patch(selector);
    }
  };


  const applicationScripts = Array.prototype.slice
    .call(document.querySelectorAll('script:not([data-cms])'))
    .filter((l) => l.getAttribute('src'))
    .filter((l) => !l.getAttribute('src').startsWith('http'))
    .map((g) => g.getAttribute('src'));

  init(selector);
};

